import React from 'react';

import { Chip } from '@mui/material';

const ConfigVersionCurrentBadge = () => (
  <Chip color="success" label="Current version" size="small" />
);

export default ConfigVersionCurrentBadge;